module.exports = __webpack_public_path__ + "img/academyBg3.be6a2eaf.jpg";